export enum PaymentPreferenceType {
    CHECK = 'Check',
    EFT = 'EFT (direct deposit)'
}